import { render, staticRenderFns } from "./ObjectEditSidebar.vue?vue&type=template&id=603d86d7&"
import script from "./ObjectEditSidebar.vue?vue&type=script&lang=js&"
export * from "./ObjectEditSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports